import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { invokeMqq, MqqNamespace } from "../data-source/mqq";
/**
 * @description 桌面端把【path】模块的【join】方法挂载到mqq上
 */
export var nodeJoinMethod = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(path) {
    var data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return invokeMqq({
            namespace: MqqNamespace.Docx,
            methodName: 'pathJoin',
            data: {
              path: path
            }
          });
        case 2:
          data = _context.sent;
          return _context.abrupt("return", data.path);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function nodeJoinMethod(_x) {
    return _ref.apply(this, arguments);
  };
}();
//# sourceMappingURL=get-local-folder-for-file.js.map